<template >
  <div v-loading="!mentor">
    <el-row v-if="mentor" :gutter="15">
      <!-- <el-col :xs="{span: 24}" :sm="{span: 8}">
        <el-card>
          <el-col :span="12">
            <p>Questions?
              <br>Click here to Chat!
            </p>
          </el-col>
          <el-col :span="12">
            <img :src="mentor.PictureUri" class="img" alt="">
          </el-col>
        </el-card>
      </el-col>-->
      <el-col :xs="{span: 24}" :sm="{span: 8}">
        <el-card>
          <span slot="header">What would you like to do?</span>
          <router-link class="button-m" tag="el-button" to="/catalog">
            <b-icon class="icon" name="oils2"/>View EO Catalog
          </router-link>
          <br>
          <router-link class="button-m" tag="el-button" to="/useCatagories">
            <b-icon class="icon" name="recipes2"/>View Uses & Recipes
          </router-link>
          <br>
          <router-link class="button-m" tag="el-button" to="/contacts">
            <b-icon class="icon" name="contacts2"/>Manage Contacts
          </router-link>
        </el-card>
      </el-col>
      <el-col :xs="{span: 24}" :sm="{span: 8}">
        <el-card>
          <span slot="header">My mentor code</span>
          <div v-if="user.IsMentor">
            <h3>{{ user.MentorCode }}</h3>
            <!-- <el-button class="button-m" type="info" plain icon="el-icon-refresh">Change Mentor Code</el-button>
            <br>-->
            <el-button
              class="button-m"
              type="info"
              plain
              icon="el-icon-share"
              @click="dialogVisible = true"
            >Share Free App</el-button>
          </div>
          <div v-else>
            <p>Create a mentor code!</p>
            <el-button type="info" icon="el-icon-info" @click="onUpgrade">Upgrade now!</el-button>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="{span: 24}" :sm="{span: 8}">
        <el-card>
          <div slot="header">
            <span>Favorite Recipes</span>
          </div>
          <favorite-recipes/>
        </el-card>
      </el-col>
      <!-- <el-col :xs="{span: 24}" :sm="{span: 8}">
        <el-card>
          <div slot="header" class="clearfix">
            <span>Refferal Program</span>
          </div>
          <p>How does it Work?</p>
          <el-button>View Details</el-button>
        </el-card>
      </el-col>-->
    </el-row>
    <el-dialog
      v-if="mentor"
      title="Share"
      fullscreen
      :modal="false"
      width="100%"
      :visible.sync="dialogVisible"
    >
      <h1>How would you like to share the app?</h1>
      <br>
      <a :href="`mailto:?subject=Droplii&body=${shareText}`">
        <el-button type="text" plain icon="el-icon-edit-outline">Email</el-button>
      </a>
      <br>
      <a :href="`sms:?&body=${shareText}`">
        <el-button type="text" plain icon="el-icon-message">Text Message</el-button>
      </a>
      <br>
      <br>
      <el-button plain @click="dialogVisible = false">Done</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FavoriteRecipes from '@/components/recipes/FavoriteRecipes'
export default {
  data() {
    return {
      dialogVisible: false,
      favoriteCollapse: ['1']
    }
  },
  computed: {
    ...mapGetters(['user', 'mentor']),
    shareText() {
      return `Hey! This is an awesome Essential Oil app I purchased for you called Droplii. It normally costs $8.99 USD but you get it free with the link below!!! It teaches you how to use the oils and even shows you how other Droplii users are using them. (use Chrome or Safari browser) https://web.droplii.com/#/signupshare?m=${
        this.user.MentorCode
      }`
    }
  },

  methods: {
    onUpgrade() {
      window.location.href = 'https://droplii.com/upgrade-pricing/'
    }
  },
  components: { FavoriteRecipes }
}
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
  /* &:last-child {
    margin-bottom: 0;
  } */
}
.el-col {
  margin-bottom: 20px;
}
.img {
  max-width: 150px;
  height: 150px;
}
.button-m {
  margin: 10px;
}
.icon {
  margin-right: 10px;
}
</style>
